import { Slide } from '@mui/material';
import type { MenuItem } from 'components/MenuTabBar';
import { Link } from 'react-router-dom';

import FormattedMessage from '../FormattedMessage';
import styles from './index.module.scss';

const MoreMenu = (props: {
  visible: boolean;
  toggleVisible: (visible: boolean) => void;
  moreMenu: MenuItem[];
}) => {
  const { visible, toggleVisible, moreMenu } = props;

  return (
    <Slide direction="up" in={visible} mountOnEnter unmountOnExit>
      <div className={styles.moreContainer}>
        <ul>
          {moreMenu.map((menu) => {
            const content = (
              <li>
                <div className={styles.menuItem}>
                  {menu.icon?.('white')}
                  <span>{menu.title}</span>
                </div>
              </li>
            );
            if (menu.external) {
              return (
                <button
                  type="button"
                  className={styles.menuButton}
                  key={menu.id}
                  onClick={() => {
                    toggleVisible(false);
                    menu.onClick?.();
                  }}
                >
                  {content}
                </button>
              );
            }
            return (
              <Link
                key={menu.id}
                to={menu.url ?? '/home'}
                onClick={() => {
                  toggleVisible(false);
                }}
              >
                {content}
              </Link>
            );
          })}
        </ul>
        <div className={styles.cancelContainer}>
          <button
            type="button"
            onClick={() => {
              toggleVisible(false);
            }}
          >
            {FormattedMessage('pointHistory.button.cancel')}
          </button>
        </div>
      </div>
    </Slide>
  );
};
export default MoreMenu;
